export const defaultProcesses = ['Recepción', 'Despacho', 'Devolución'];
